import React, { Component } from 'react';
import Eventpopup from './popup/Eventpopup';
import Eventaddpopup from './popup/Eventaddpopup';
import $ from 'jquery';
import {
  isMobile, isIOS
} from "react-device-detect";

export default class Selectoption extends Component {
    constructor(props)
    {
        super(props);
        this.loginKey = localStorage.getItem('loginKey');
        if(  this.loginKey === "" || !this.loginKey ) {
          this.loginKey = sessionStorage.getItem('loginKey');
        }
    }
    componentDidMount()
    {
      //if(!isIOS)
      //{
      this.checkPopup();
      //}
    }
    checkPopup()
    {
      const self = this;
      $.post('https://api.tfamily.co.kr/api/mobile/init',{},function(data){
        let pData = JSON.parse(data);
        if(pData.data && pData.data.popup)
        {
          if( pData.data.popup.length > 0 )
          {
            let first_popup = (pData.data.popup[0]);
            if( first_popup ) {
              let resultPopup = window.getCookie('popup' + first_popup.idx);
              if( resultPopup != 1 )
              {
                  self._eventPopup.Open(pData.data.popup);
              }
            }
          }
        }
      });
    }
    movePage(idx)
    {
        if ( idx == 50 ) {
            window.location.href = 'https://sfamily.kr/jkl/barun/login_tfamily.php?uk=' + this.loginKey;
        } else
            window.location.href = '/?idx=' + idx;
    }
    onJoinChanged(_title)
    {
      this._eventPopup.Close();
      if( this.loginKey && this.loginKey != "") {
          this._eventAddpopup.Open(_title);
      }
/*
      else {
          alert('로그인이 필요합니다');
      }
*/
    }
    render()
    {
        const self = this;
        return (
            <div className="centralize-wrapper">
              <div className="header text-center pt10 lightgray">
                본 웹사이트는 임직원 및 가족을 위한 공간입니다.
              </div>
                <div className="centralize-inner">
                    <div className="container">
                        <div className={'row ' +  ((isMobile) ? 'menu-option pt40' : 'menu-option pt15')}>
                            <div className="col-lg-3 col-md-3 col-xs-12 ">
                                <div className="card cardhover borderlight" onClick={()=>{self.movePage(1)}}>
                                <div className="text-center">
                                    <h4 className="my-0 font22 font-weight-normal">신규가입</h4>
                                    <div className="lightgray">
                                      SK텔레콤에 새로 오신<br/> 고객님 환영합니다.
                                    </div>
                                </div>
                                    <div className="card-header text-center">
                                        <img className="maxwidth200" src={'img/icon_phone_new.png'} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-xs-12">
                                <div className="card cardhover borderlight" onClick={()=>{self.movePage(3)}}>
                                    <div className="text-center">
                                        <h4 className="my-0 font22 font-weight-normal">번호이동</h4>
                                        <div className="lightgray">
                                          최고의 통신사 SK텔레콤으로<br/> 오신 것을 환영합니다.
                                        </div>
                                    </div>
                                    <div className="card-header text-center">
                                        <img className="maxwidth200" src={'img/icon_phone_cha.png'} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-xs-12">
                                <div className="card cardhover borderlight" onClick={()=>{self.movePage(2)}}>
                                    <div className="text-center">
                                        <h4 className="my-0 font22 font-weight-normal">기기변경</h4>
                                        <div className="lightgray">
                                          최신형 핸드폰 T패밀리몰에서<br/> 지금 바로 만나보세요.
                                        </div>
                                    </div>
                                    <div className="card-header text-center">
                                        <img className="maxwidth200" src={'img/icon_phone_gigi.png'} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-xs-12">
                                <div className="card cardhover borderlight" onClick={()=>{self.movePage(50)}}>
                                    <div className="text-center">
                                        <h4 className="my-0 font22 font-weight-normal">S패밀리몰(임시오픈)</h4>
                                        <div className="lightgray">
                                        S패밀리몰에서 삼성전자 제품을<br/>특판가격으로 만나보세요.
                                            </div>
                                    </div>
                                    <div className="card-header text-center">
                                        <img className="maxwidth200" src={'img/icon_samsung.png'} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                          <br/><br/>
                          <a href="http://www.ictmarket.or.kr/agent/pop_AgentCertIcon.do?AGENT_REQ_ID=AGT0000197611&AGENT_CD=D33715" target="_blank"><img className="maxwidth120 pr10" src={'img/winnerlogo.png'} /></a>
                        </div>
                    </div>
                </div>
                <Eventpopup onJoinChanged={(title)=>{self.onJoinChanged(title)}}  ref={(ref=>{this._eventPopup=ref;})} />
                <Eventaddpopup ref={(ref)=>{this._eventAddpopup=ref}} />
            </div>
        )
    }
}
